import { render, staticRenderFns } from "./NewsCon.vue?vue&type=template&id=7ae13c66&scoped=true"
import script from "./NewsCon.vue?vue&type=script&lang=js"
export * from "./NewsCon.vue?vue&type=script&lang=js"
import style0 from "./NewsCon.vue?vue&type=style&index=0&id=7ae13c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae13c66",
  null
  
)

export default component.exports